// extracted by mini-css-extract-plugin
export default {"background":"#f4f5f9","blackBlue":"#42567a"};